import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";
import { UserAddInfo } from "../pages/admin/admin-list-user/adminListUser";
import { UserInfo, userInfoResponse, UserResponse } from "../store/UserSlice";
import { SendDocumentDto } from "../models/User";

const target = "/users";

export class UserService {

    public static getAllUsers() : Promise<Array<UserResponse>>{
        return Api.get(apiUrl(target));
    }

    public static fecthUser(id:number) : Promise<UserInfo> {
        return Api.get(apiUrl(target+"/"+id));
    }

    public static getUserByOrganization(id:number): Promise<Array<UserResponse>>{
        return Api.get(apiUrl(target+"/organization/"+id));
    }

    public static addUser(payload: UserAddInfo, register: string = 'dashboard') {
        return Api.post(apiUrl(target+"/create/"+register), payload);
    }

    public static updateStatus(userId: number, status: string) {
        return Api.put(apiUrl(target+"/"+userId), { status });
    }

    public static resetPassword(userId: number) {
        return Api.patch(apiUrl(target+"/"+userId+"/reset-password"), {});
    }

    public static getUsersClients(orgId:number) {
        return Api.get(apiUrl(target+"/clients/"+orgId));
    }

    public static getUsersDepositors(orgId:number) {
        return Api.get(apiUrl(target+"/depositors/"+orgId));
    }

    public static getUserWallets(userId:number) {
        return Api.get(apiUrl(target+"/wallets/"+userId));
    }

    public static getUserDeposits(userId:number) {
        return Api.get(apiUrl(target+"/depoists/"+userId));
    }

    public static getUserQuotes(userId:number) {
        return Api.get(apiUrl(target+"/quotes/"+userId));
    }

    public static sendDocument(userId:number, data: SendDocumentDto) {
         return Api.post(apiUrl(target+"/document/"+userId), {data});
    }

    public static getUserHardWallets(userId:number) {
        return Api.get(apiUrl(target+"/hardWallets/"+userId));
    }

    public static addOrgToUser(payload:any) {
        return Api.post(apiUrl(target+"/organization/link"), payload);
    }

    public static getBlocked(id:number) : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/organization/"+id+"/blocked"));
    }

    public static searchKyc(query: string) : Promise<any> {
        return Api.get(apiUrl(`${target}/kyc/search?q=${encodeURIComponent(query)}`));
    }

}